type LiveSessionWithChannel = {
  youtube_channel?: {
    id: string;
  } | null;
};

export function matchLiveSessionForChannel<T extends LiveSessionWithChannel>(
  sessions: readonly T[],
  channelDocumentId: string,
): T | null {
  return sessions.find(
    (session) => session.youtube_channel?.id === channelDocumentId,
  ) ?? null;
}
